import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=f95ebc56&scoped=true"
import script from "./settings.vue?vue&type=script&lang=js"
export * from "./settings.vue?vue&type=script&lang=js"
import style0 from "./settings.vue?vue&type=style&index=0&id=f95ebc56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95ebc56",
  null
  
)

export default component.exports